/* eslint-disable */
// ####################################+################################################
// ################# THIS IS GENERATED FILE DO NOT TOUCH!!!!!!!!!!!!####################
// ####################################-################################################
import type * as Types from '../packlets/generated'

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type PendingUserFragmentFragment = {
  __typename?: 'PendingUser'
  id: string
  createdAt: string
  updatedAt: string
}

export type PricingDataFragmentFragment = {
  __typename?: 'PricingData'
  discountedPriceCents?: number | null | undefined
  priceCents: number
  currency: Types.CurrencyCode
  productId: string
  discountMetadata?:
    | {
        __typename?: 'DiscountMetadata'
        type: Types.DiscountType
        amount: number
      }
    | null
    | undefined
}

export type GetPricingDataQueryVariables = Types.Exact<{
  input: Types.GetPricingDataInput
}>

export type GetPricingDataQuery = {
  __typename?: 'Query'
  getPricingData: {
    __typename?: 'GetPricingDataResponse'
    monthly: {
      __typename?: 'PricingData'
      discountedPriceCents?: number | null | undefined
      priceCents: number
      currency: Types.CurrencyCode
      productId: string
      discountMetadata?:
        | {
            __typename?: 'DiscountMetadata'
            type: Types.DiscountType
            amount: number
          }
        | null
        | undefined
    }
    annual: {
      __typename?: 'PricingData'
      discountedPriceCents?: number | null | undefined
      priceCents: number
      currency: Types.CurrencyCode
      productId: string
      discountMetadata?:
        | {
            __typename?: 'DiscountMetadata'
            type: Types.DiscountType
            amount: number
          }
        | null
        | undefined
    }
  }
}

export type CreateStripeCheckoutMutationVariables = Types.Exact<{
  input: Types.CreateStripeCheckoutInput
}>

export type CreateStripeCheckoutMutation = {
  __typename?: 'Mutation'
  createStripeCheckout: {
    __typename?: 'CreateSessionCheckoutResponse'
    sessionId: string
  }
}

export type ValidateCheckoutMutationVariables = Types.Exact<{
  input: Types.ValidateSessionCheckoutInput
}>

export type ValidateCheckoutMutation = {
  __typename?: 'Mutation'
  validateStripeCheckout: {
    __typename?: 'PendingUser'
    id: string
    createdAt: string
    updatedAt: string
  }
}

export type CreateStripeBillingPortalMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']
  input: Types.CreateStripeBillingPortalInput
}>

export type CreateStripeBillingPortalMutation = {
  __typename?: 'Mutation'
  createStripeBillingPortal: {
    __typename?: 'CreateBillingPortalResponse'
    url: string
  }
}

export type ResubscribeMemberMutationVariables = Types.Exact<{
  input: Types.ResubscribeMemberInput
}>

export type ResubscribeMemberMutation = {
  __typename?: 'Mutation'
  resubscribeMember: boolean
}

export type UpgradeMemberToAnnualMutationVariables = Types.Exact<{
  [key: string]: never
}>

export type UpgradeMemberToAnnualMutation = {
  __typename?: 'Mutation'
  upgradeMemberToAnnual: boolean
}

export const PendingUserFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PendingUserFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PendingUser' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PendingUserFragmentFragment, unknown>
export const PricingDataFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PricingDataFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PricingData' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discountedPriceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'priceCents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discountMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PricingDataFragmentFragment, unknown>
export const GetPricingDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPricingData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GetPricingDataInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPricingData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'monthly' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PricingDataFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'annual' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PricingDataFragment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...PricingDataFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetPricingDataQuery, GetPricingDataQueryVariables>
export const CreateStripeCheckoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStripeCheckout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateStripeCheckoutInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStripeCheckout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateStripeCheckoutMutation,
  CreateStripeCheckoutMutationVariables
>
export const ValidateCheckoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ValidateCheckout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ValidateSessionCheckoutInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateStripeCheckout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PendingUserFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...PendingUserFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ValidateCheckoutMutation,
  ValidateCheckoutMutationVariables
>
export const CreateStripeBillingPortalDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStripeBillingPortal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateStripeBillingPortalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStripeBillingPortal' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateStripeBillingPortalMutation,
  CreateStripeBillingPortalMutationVariables
>
export const ResubscribeMemberDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResubscribeMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResubscribeMemberInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resubscribeMember' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResubscribeMemberMutation,
  ResubscribeMemberMutationVariables
>
export const UpgradeMemberToAnnualDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpgradeMemberToAnnual' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upgradeMemberToAnnual' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpgradeMemberToAnnualMutation,
  UpgradeMemberToAnnualMutationVariables
>
